import {Inject, Injectable, InjectionToken} from '@angular/core';
import {MatDynamicTableModuleConfig} from './configs/mat-dynamic-table-module.config';
import {BaseColumn} from '../shared/columns/base-column.model';

export const MatDynamicTableModuleConfigInjectionToken = new InjectionToken<MatDynamicTableModuleConfig>('MatDynamicTableModuleConfig');


@Injectable({
  providedIn: 'root'
})
export class MatDynamicTableService {

  constructor(@Inject(MatDynamicTableModuleConfigInjectionToken) public moduleConfig: MatDynamicTableModuleConfig) {
  }

  getParsedData(data: any[], columns: BaseColumn[]): any[] {
    const resArray: any[] = [];

    data.forEach(element => {
      const resElement: { [key: string]: any } = {};
      columns.forEach(column => {
        resElement[column.title] = column.get(element);
      });
      resArray.push(resElement);
    });

    return resArray;
  }

}

